import React, { createContext, useContext, useEffect, useState } from 'react';
import { listBoards, createBoard } from '../lib/api';
import { useAuth } from './AuthContext';

const BoardContext = createContext(null);

export const BoardProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const [boards, setBoards] = useState([]);
  const [activeBoard, setActiveBoard] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshBoards = async () => {
    try {
      setLoading(true);
      const data = await listBoards();
      setBoards(data);
      const savedId = localStorage.getItem('digilean_active_board');
      const found = data.find((b) => b.id === savedId);
      if (found) setActiveBoard(found);
      else if (data.length > 0) setActiveBoard(data[0]);
      else setActiveBoard(null);
    } catch (e) {
      console.error('Failed to load boards', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated) refreshBoards();
    else if (isAuthenticated === false) {
      setBoards([]);
      setActiveBoard(null);
      setLoading(false);
    }
  }, [isAuthenticated]);

  const selectBoard = (board) => {
    setActiveBoard(board);
    if (board) localStorage.setItem('digilean_active_board', board.id);
  };

  const addBoard = async (payload) => {
    const newBoard = await createBoard(payload);
    setBoards((prev) => [newBoard, ...prev]);
    selectBoard(newBoard);
    return newBoard;
  };

  const updateActiveBoard = (updated) => {
    setBoards((prev) => prev.map((b) => (b.id === updated.id ? updated : b)));
    if (activeBoard?.id === updated.id) setActiveBoard(updated);
  };

  const currentUserEmail = user?.default_owner_email || user?.email || '';

  return (
    <BoardContext.Provider
      value={{
        boards,
        activeBoard,
        selectBoard,
        addBoard,
        refreshBoards,
        updateActiveBoard,
        loading,
        currentUserEmail,
      }}
    >
      {children}
    </BoardContext.Provider>
  );
};

export const useBoards = () => {
  const ctx = useContext(BoardContext);
  if (!ctx) throw new Error('useBoards must be used within BoardProvider');
  return ctx;
};
